export const SIGN_UP = "/signup";
export const SIGN_IN = "/";
// export const LANDING = "/";
export const SHOP = "/shop";
export const HOME = "/home";
export const PASSWORD_FORGET = "/pw-forget";
export const UPDATE_PASSWORD = "/update-password";
export const MONTH_VIEW = "/month-view";
export const DAILY_VIEW = "/daily-view";
export const FILTER_VIEW = "/filter-view";
export const USER_VERIFICATION = "/user-vefification";
export const STATISTICS_VIEW = "/statistics";
export const LOAN_VIEW = "/loan";
export const SETTINGS_VIEW = "/settings";
export const SAVINGS_VIEW = "/savings";
